import styled from 'styled-components/macro';
import { Position } from 'type';

type DotProps = Position & {
  color: string;
};

export const Dot = styled.span<DotProps>`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background-color: ${({ color }) => color};
  display: inline-block;
  position: absolute;
  left: ${({ x }) => x - 0}px;
  top: ${({ y }) => y - 6}px;
  z-index: 99;
`;

type LinePosition = Position & {
  height: number;
  color: string;
};

export const Line = styled.div<LinePosition>`
  border-left: 3px dashed ${({ color }) => color};
  height: ${({ height }) => height}px;
  left: ${({ x }) => x + 7}px;
  top: ${({ y }) => y}px;
  position: absolute;
`;
